import { Snackbar, Alert } from "@mui/material";
import { useToast } from "@/store/toast";

/**
 * Single app-wide snackbar driven by the {@link useToast} store. Mounted once at the root so any
 * code (including the TanStack Query mutation cache) can surface a toast via `notify.success(...)`.
 * Important for create flows behind pagination — the new row may land on another page, so the
 * toast is the user's confirmation that the save worked.
 */
export function GlobalToast() {
  const { open, message, severity, close } = useToast();
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={(_e, reason) => { if (reason !== "clickaway") close(); }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={close} severity={severity} variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
